module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "decication"
  }, [_c('a', {
    attrs: {
      "id": "dedication"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("His heart,"), _c('br'), _vm._v("\n  in childhood, always delighted"), _c('br'), _vm._v("\n  in every leaf, every slice of sky,"), _c('br'), _vm._v("\n  contemplating his village. This future"), _c('br'), _vm._v("\n  was unaware that today"), _c('br'), _vm._v("\n  the horizon aligns itself with other"), _c('br'), _vm._v("\n  indifferences. Everything has happened:"), _c('br'), _vm._v("\n  in us, by fate,"), _c('br'), _vm._v("\n  we are prisoners of regret"), _c('br'), _vm._v("\n  for our innocence.")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Pier Paolo Pasolini, “Europa”"), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 72
// module chunks = 0